import styled from "styled-components";
import { Card } from "react-bootstrap";
import { styled as MUIStyled } from "@mui/material/styles";
import { Rating, Skeleton } from "@mui/material";

export const StyledCard = styled(Card)`
  border-radius: 20px;
  background-color: var(--bg-color);
  box-shadow: var(--box-shadow-labs);
  max-width: ${({ $Carousel }) => ($Carousel ? "290px" : "360px")};
  ${({ $Carousel }) => $Carousel && "max-height: 304px"};
  transition: all 0.3s ease;
  &:hover {
    transform: translateY(-5px);
  }
  .card-body {
    display: flex;
    flex-direction: column;
    row-gap: ${({ $Carousel }) => ($Carousel ? "1rem" : "1.5rem")};
    h5 {
      color: var(--text-color-dark);
      font-size: ${({ $Carousel }) =>
        $Carousel ? "var(--font-size-base)" : "var(--font-size-lg)"};
      font-weight: 500;
    }
    p {
      color: var(--text-color-dark);
      font-size: ${({ $Carousel }) =>
        $Carousel ? "var(--font-size-base)" : "var(--font-size-md)"};
      font-weight: 400;
    }
  }
`;

export const StyledSkeleton = styled(Skeleton)`
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
`;

export const StyledCardImg = styled(Card.Img)`
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
  max-height: 180px;
`;

export const SimCardLabel = styled(Card.ImgOverlay)`
  right: initial;
  left: 12px;
  top: 12px;
  width: 120px;
  height: 34px;
  background-color: var(--secondary-color);
  color: var(--dark-color);
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CardScoreDiv = styled.div`
  column-gap: 5px;
  &:first-child {
    color: var(--deactive-color);
  }
`;

export const StyledRating = MUIStyled(Rating)({
  "&.MuiRating-root": {
    marginRight: "1rem",
  },
  "& .MuiRating-iconFilled": {
    color: "var(--primary-color)",
  },
});
